import React, { useState } from 'react'
import './Configurations.css';
//componnets
import TabComponent from '../../../components/TabComponent/TabComponent'
import SuggestedPrice from '../Support/SuggestedPrice/SuggestedPrice'
import Level from './Level/Level'
import NeedHelp from './NeedHelp/NeedHelp'

const Configurations = () => {
  const [activeTab, setActiveTab] = useState('suggested_price');
  const tabs = [
    { id: 'suggested_price', label: 'Suggested Price' },
    { id: 'level_knowledge', label: 'Level of knowledge' },
    { id: 'need_help', label: 'I need help' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'suggested_price':
        return <SuggestedPrice />
      case 'level_knowledge':
        return <Level />
      case 'need_help':
        return <NeedHelp />
      default:
        return null;
    }
  };

  return (
    <div className="configurations_content">
      <TabComponent
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      >
        {renderTabContent()}
      </TabComponent>
    </div>
  )
}

export default Configurations